import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { SyllabusService, LessonFilter, LessonListResponse, LessonDetail } from '@/services/syllabusService';
import {
    fetchAiLessonsRequest,
    fetchAiLessonsSuccess,
    fetchAiLessonsFailure,
    fetchLessonByIdRequest,
    fetchLessonByIdSuccess,
    fetchLessonByIdFailure,
    IGetListSkillsParams,
} from '../slices/syllabusSlice';

function* fetchAiLessonsSaga(action: PayloadAction<IGetListSkillsParams>) {
    try {
        const response: LessonListResponse = yield call(SyllabusService.fetchAiLessons, action.payload);
        yield put(
            fetchAiLessonsSuccess({
                lessons: response.results,
                skillCounts: response.skill_counts,
                count: response.count,
                page: response.page,
                page_size: response.page_size,
            }),
        );
    } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : 'Failed to fetch AI lessons';
        yield put(fetchAiLessonsFailure(errorMessage));
    }
}

function* fetchLessonByIdSaga(action: PayloadAction<number>) {
    try {
        const lesson: LessonDetail = yield call(SyllabusService.fetchLessonById, action.payload);
        yield put(fetchLessonByIdSuccess(lesson));
    } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : 'Failed to fetch lesson';
        yield put(fetchLessonByIdFailure(errorMessage));
    }
}

export function* syllabusSaga() {
    yield takeLatest(fetchAiLessonsRequest.type, fetchAiLessonsSaga);
    yield takeLatest(fetchLessonByIdRequest.type, fetchLessonByIdSaga);
} 